import React, { useState } from 'react';
import { withApollo } from '@apollo/client/react/hoc';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useForm } from 'react-final-form';
import {
  setIsLoadingResultByNumber,
  setResultByNumber
} from '../../../../../actions';
import { Input, InputTypeMap } from '../../../../ui/Input';
import { FiltersSection } from '../FiltersSection';
import { InputWrapper } from './styled';
import { getItemId } from '../../../../../api/queries';
import { ItemIdQuery } from '../../../../../graphql/graphql';

export const NewSearchAdNumber = withApollo(({ client }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { change } = useForm();
  const [query, setQuery] = useState('');

  const resetResult = () => {
    dispatch(setResultByNumber({ hasAnyResult: false, result: null }));
  };

  const resetValue = () => {
    setQuery('');
    resetResult();
  };

  const fetchData = async () => {
    if (query.length >= 5 && query.length <= 10) {
      dispatch(setIsLoadingResultByNumber(true));
      try {
        const response: { data: ItemIdQuery } = await client?.query({
          query: getItemId,
          variables: { id: query }
        });
        dispatch(
          setResultByNumber({
            hasAnyResult: true,
            result: response?.data.item
          })
        );
      } catch (err) {
        console.error(err);
      } finally {
        dispatch(setIsLoadingResultByNumber(false));
      }
    } else {
      resetResult();
    }
  };

  const handleBlur = () => {
    fetchData();
    change('ad_number', query);
  };

  return (
    <FiltersSection
      data-stat="new-search-form-ad-number"
      title={t('pages.profile.operations_history.ad_number')}
    >
      <InputWrapper>
        <Input
          value={query}
          name="ad_number"
          isFullWidth={true}
          onChange={setQuery}
          onReset={resetValue}
          type={InputTypeMap.range}
          id="search-form-search-by-number"
          placeholder="123456"
          onBlurHandler={handleBlur}
          isCustomInput
        />
      </InputWrapper>
    </FiltersSection>
  );
});
